import type { IPromotionRepository, ClonePromotionInput } from '@/features/promotion/domain/repositories/IPromotionRepository.js';

export const createCloneSchemeUseCase = ({ promotionRepository }: { promotionRepository: IPromotionRepository }) =>
  (input: ClonePromotionInput) => promotionRepository.cloneScheme(input);
